import React from 'react';
import { Field, RadioGroup } from '../../../../Core';
import { ListFieldSection, FieldSet, PageSection } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import AstmCompactionMethodSection from './CompactionMethodSection';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { AdditionalVisualDescription } from 'Components/Worksheets/Core/Fields';

let AstmPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const allowVisualDescriptionEntry = useSelector(
    createWorksheetSelector!('Preparation.AllowAdditionalVisualDescriptionEntry')
  );

  return (
    <PageSection heading="Preparation">
      <ListFieldSection>
        <FieldSet>
          <Field
            input={<RadioGroup />}
            label="Preparation Method"
            name="Preparation.PreparationMethod"
            options={['Moist', 'Dry'].map((e) => ({ label: e, value: e }))}
          />
        </FieldSet>
        <AdditionalVisualDescription editable visible={allowVisualDescriptionEntry} appendNamePrefix="Preparation" />
      </ListFieldSection>
      <AstmCompactionMethodSection />
    </PageSection>
  );
};

AstmPreparationSection = withInjectedProps(AstmPreparationSection);

export { AstmPreparationSection };
export default AstmPreparationSection;
